import { WSServiceError } from "./serviceHelper";

const getFetchError = (error: any) =>
  (error as WSServiceError).response || error;

export default getFetchError;
